import React, {useEffect, useState} from 'react';
import {Header} from "../../widgets/header";
import {Footer} from "../../widgets/footer";
import {Outlet, useLocation} from "react-router-dom";
import S from './Layout.module.scss';
import {ScrollToTopButton} from "../../shared/components/scrollToTopButton";

export const Layout = () => {

  const location = useLocation();
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const element = document.getElementById(id);

      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    }
  }, [location]);

  return (
    <div className={S.layout}>
      <header>
        <Header/>
      </header>
      <main className={S.main}>
        <Outlet/>
      </main>
      <Footer/>
      <ScrollToTopButton/>
    </div>
  );
}